export default "__VITE_ASSET__DUSeYIhe__"